import React from 'react'
import { Box } from '@chakra-ui/react'

const Hero = ({ children }, props) => <Box {...props}>{children}</Box>

export default Hero
